import { useTranslation } from 'react-i18next';

import type { WitnessStatus } from '@/api/types';
import { cn } from '@/utils/cn';

export function WitnessChip({ status }: { status: WitnessStatus }) {
  const { t } = useTranslation('attestations');
  const label =
    status === 'ok'
      ? t('entry.witness_ok')
      : status === 'pending'
        ? t('entry.witness_pending')
        : t('entry.witness_down');
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium',
        status === 'ok' && 'bg-success/10 text-success',
        status === 'pending' && 'bg-warn/10 text-warn',
        status === 'down' && 'bg-danger/10 text-danger',
      )}
    >
      <span
        aria-hidden="true"
        className="inline-block h-1.5 w-1.5 rounded-full bg-current opacity-80"
      />
      {label}
    </span>
  );
}
